import { u as n, o as s, b as r, c as p, e as c, j as i, n as u } from "./define-element-XpjsV6s1.js";
/* empty css                                                                */
import { _ as f } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const l = {
  __name: "Button",
  props: {
    variant: {
      type: String,
      default: "primary"
    },
    // "sm" | "md" | "lg" — font size from --offset-btn-font-size-sm /
    // --offset-btn-font-size / --offset-btn-font-size-lg (CMS Theme → Buttons).
    size: {
      type: String,
      default: "md"
    }
  },
  setup(e) {
    const t = e, o = n("container");
    return s(() => {
      r(o.value);
    }), (a, d) => (p(), c("button", {
      ref: "container",
      type: "button",
      class: u(["offset-button", t.variant, `size-${t.size}`])
    }, [
      i(a.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}, y = /* @__PURE__ */ f(l, [["__scopeId", "data-v-de9a7d82"]]);
export {
  y as B
};
